import LazyLoad from 'react-lazyload';
import ContentLoader from 'src/components/content-loader';
import { APP_IMG } from 'src/constants';

export const KEY_IMAGE = {
  FEATURE_IMAGE: 'FEATURE_IMAGE',
  COVER_IMAGE: 'COVER_IMAGE',
  CARD_LARGE: 'CARD_LARGE',
  CARD_MEDIUM: 'CARD_MEDIUM',
  CARD_SMALL: 'CARD_SMALL'
};

const Image = ({
  title,
  image,
  ignoreLazy,
  horizontal = false,
  exLazy = '',
  external = false,
  type,
  priority = false // ★ new
}) => {
  const loading = priority ? 'eager' : 'lazy';
  const fetchPriority = priority ? 'high' : 'auto';
  const decoding = priority ? 'async' : 'async';

  if (!image) {
    if (priority) return null;
    return (
      <div className='resolution-image'>
        <img
          src={`${APP_IMG}/default.jpg`}
          alt={title || 'image'}
          loading='lazy'
          width='100%'
          height='100%'
        />
      </div>
    );
  }

  const imgUrl = external ? image : `${APP_IMG}${image}`;

  const imgProps = {
    alt: title,
    loading,
    fetchpriority: fetchPriority,
    decoding,
    className: exLazy,
    width: '100%',
    height: '100%'
  };

  let elem;
  switch (type) {
    case KEY_IMAGE.FEATURE_IMAGE:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/LG-webp`} type='image/webp' />
          <img src={`${imgUrl}?x-image-process=style/LG`} {...imgProps} />
        </picture>
      );
      break;

    case KEY_IMAGE.COVER_IMAGE:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/LG-webp`} media={'(max-width: 767px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/LG`} media={'(max-width: 767px)'} type='image/jpeg' />
          <source srcSet={`${imgUrl}?x-image-process=style/XL-webp`} type='image/webp' />
          <img src={`${imgUrl}?x-image-process=style/XL`} {...imgProps} />
        </picture>
      );
      break;

    case KEY_IMAGE.CARD_LARGE:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/MD-webp`} media={'(max-width: 767px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/MD`} media={'(max-width: 767px)'} type='image/jpeg' />
          <source srcSet={`${imgUrl}?x-image-process=style/LG-webp`} type='image/webp' />
          <img src={`${imgUrl}?x-image-process=style/LG`} {...imgProps} />
        </picture>
      );
      break;

    case KEY_IMAGE.CARD_MEDIUM:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/MD-webp`} media={'(max-width: 767px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/MD`} media={'(max-width: 767px)'} type='image/jpeg' />
          <source srcSet={`${imgUrl}?x-image-process=style/MD-webp`} type='image/webp' />
          <img src={`${imgUrl}?x-image-process=style/MD`} {...imgProps} />
        </picture>
      );
      break;

    case KEY_IMAGE.CARD_SMALL:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/SS-webp`} media={'(max-width: 767px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/SS`} media={'(max-width: 767px)'} type='image/jpeg' />
          <source srcSet={`${imgUrl}?x-image-process=style/XS-webp`} type='image/webp' />
          <img src={`${imgUrl}?x-image-process=style/XS`} {...imgProps} />
        </picture>
      );
      break;

    default:
      elem = (
        <picture className='resolution-image'>
          <source srcSet={`${imgUrl}?x-image-process=style/MD-webp`} media={'(max-width: 768px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/MD`} media={'(max-width: 768px)'} type='image/jpeg' />
          <source srcSet={`${imgUrl}?x-image-process=style/LG-webp`} media={'(max-width: 1440px)'} type='image/webp' />
          <source srcSet={`${imgUrl}?x-image-process=style/LG`} media={'(max-width: 1440px)'} type='image/jpeg' />
          <img src={`${imgUrl}?x-image-process=style/LG`} {...imgProps} />
        </picture>
      );
  }

  // ★ priority → ข้าม LazyLoad wrapper ทั้งหมด, render ตรงๆ
  if (priority || ignoreLazy) return elem;

  return (
    <LazyLoad placeholder={<ContentLoader hasText={false} horizontal={horizontal} />}>
      {elem}
    </LazyLoad>
  );
};

export default Image;
